const getNow = () =>
  typeof performance !== 'undefined' && typeof performance.now === 'function'
    ? performance.now()
    : Date.now();

const getPlatformLabel = () => {
  if (typeof window === 'undefined') return 'server';

  const maybeCapacitorPlatform =
    typeof window.Capacitor?.getPlatform === 'function'
      ? window.Capacitor.getPlatform()
      : null;

  if (maybeCapacitorPlatform) {
    return `capacitor:${maybeCapacitorPlatform}`;
  }

  const ua = window.navigator?.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios-web';
  if (/Android/i.test(ua)) return 'android-web';
  return 'web';
};

export const logPerf = (label, details = {}) => {
  const timestamp = new Date().toISOString();
  console.log(`[Perf][${timestamp}][${getPlatformLabel()}] ${label}`, details);
};

export const createPerfTrace = (label, baseDetails = {}) => {
  const startedAt = getNow();
  let lastMark = startedAt;

  logPerf(`${label}:start`, baseDetails);

  return {
    step(stepLabel, details = {}) {
      const now = getNow();
      const elapsedMs = Math.round(now - startedAt);
      const deltaMs = Math.round(now - lastMark);
      lastMark = now;
      logPerf(`${label}:${stepLabel}`, {
        ...baseDetails,
        ...details,
        elapsedMs,
        deltaMs,
      });
    },
    end(details = {}) {
      const now = getNow();
      const totalMs = Math.round(now - startedAt);
      logPerf(`${label}:end`, {
        ...baseDetails,
        ...details,
        totalMs,
      });
    },
    fail(error, details = {}) {
      const now = getNow();
      const totalMs = Math.round(now - startedAt);
      logPerf(`${label}:error`, {
        ...baseDetails,
        ...details,
        totalMs,
        errorMessage: error?.message || String(error),
        errorCode: error?.code || null,
      });
    },
  };
};
